import { io } from "socket.io-client";

let socket;
let connectPromise = null;

// Connect to the Socket.IO server
export const connectWebSocket = () => {
  if (socket && socket.connected) {
    return Promise.resolve(socket);
  }

  if (!connectPromise) {
    connectPromise = new Promise((resolve, reject) => {
      socket = io(process.env.REACT_APP_CLIENT_URL, {
        path: "/socket.io",
        transports: ["websocket", "polling"],
        secure: true, // browser enforces this automatically
        extraHeaders: {
          "Content-Type": "application/json",
        },
      });

      socket.on("connect", () => {
        console.log("✅ Socket.IO connected");
        resolve(socket);
      });

      socket.on("connect_error", (err) => {
        console.error("❌ Socket.IO connection error", err);
        reject(err);
        connectPromise = null;
      });

      socket.on("disconnect", () => {
        console.log("🔌 Socket.IO disconnected");
        connectPromise = null;
      });
    });
  }

  return connectPromise;
};

// Send the word
export const sendWord = async (word) => {
  try {
    const socket = await connectWebSocket();
    socket.emit("request-from-clientUI", { word });
    console.log(`✅ Sent word to DMC server: ${word}`);
  } catch (err) {
    console.error("❌ Could not send word via Socket.IO", err);
  }
};

// Send the view mode
export const sendViewMode = async (mode) => {
  try {
    const socket = await connectWebSocket();
    socket.emit("request-from-clientUI", { view_mode: mode });
    console.log(`✅ Sent view_mode to DMC server: ${mode}`);
  } catch (err) {
    console.error("❌ Could not send view_mode via Socket.IO", err);
  }
};
